<template>
  <div class="scanIntoStoreage">
      <div class="scan_wrapper">
          <el-input style="width:100%;height:60px" v-if="!flag" v-model="pruchaseId" prefix-icon="el-icon-search" @change="getPurchaseData()" :placeholder="$t('scanIntoStoreage.treybvc')"></el-input>
          <el-input style="width:100%;height:60px" v-if="flag" v-model="productBarcode" prefix-icon="el-icon-search" @change="scanProduct()" :placeholder="$t('scanIntoStoreage.qwefc')"></el-input>
      </div>
      <div class="desc_box">
          <span style="display:flex">
              <span class="desc_item">{{$t('scanIntoStoreage.ivnfiln')}}{{purchaseData.purchaseOrderId ? purchaseData.purchaseOrderId : $t('other.a354')}}</span>
                <span class="desc_item">{{$t('scanIntoStoreage.vklnf')}}{{purchaseData.sellerId ? purchaseData.sellerId : $t('other.a354')}}</span>
                <span class="desc_item">{{$t('other.a964')}}{{purchaseData.productNum ? purchaseData.productNum : 0}}{{$t('other.a1201')}}</span>
                <span class="desc_item">{{$t('scanIntoStoreage.oeknv')}}{{purchaseData.total  ?  purchaseData.total : $t('other.a354')}}</span>
                <span class="desc_item">{{$t('scanIntoStoreage.oevlknv')}}{{total}}</span>
                 <span style="color:red;font-weight:bold;margin-left:15px">{{$t('scanIntoStoreage.obvpkf')}}<el-input style="width:150px;font-size:15px" size="mini" v-model="fee" :placeholder="$t('other.a1560')"></el-input></span>
          </span>
          <div class="ooi">
                <el-button  type="primary" @click="exportData()">{{$t('other.a2510')}}</el-button>
              <el-button  type="primary" @click="resetOrder()">{{$t('scanIntoStoreage.mmnnkv')}}</el-button>
              <el-button  type="primary" @click="resetNum()">{{$t('scanIntoStoreage.wiubvm')}}</el-button>
              <el-button v-show="purchaseData.orderFlag == 'UNAUDITED'"  type="danger" @click="confirm()">{{$t('scanIntoStoreage.ornkf')}}</el-button>
              <el-button v-show="purchaseData.orderFlag !== 'UNAUDITED'"  type="danger" >{{$t('scanIntoStoreage.wecbdk')}}</el-button>
          </div>
      </div>
      <div>
          
      </div>
      <div v-if="purchaseData.messageToSeller" class="box_wrappr">
           <i class="iconfont icon-tixing1"><span style="font-size:16px;margin:0 10px">{{$t('scanIntoStoreage.ovmoinv')}}</span></i>
            <div class="box" >
            <p class="animate">{{purchaseData.messageToSeller}}</p>
        </div>
      </div>
      <!--  -->
      <div class="table">
          <el-table
           ref="ttp"
            :data="list"
            border
           :row-class-name="tableRowClassName"
            style="width: 100%">
            <el-table-column
            label="product"
                width="100">
                <template slot-scope="images" >
                    <div style="width: 80px;height: 80px">
                        <img :src="images.row.image" alt="" style="width:100%">
                    </div>   
                </template>
            </el-table-column>
            <el-table-column label="cusCode">
                <template slot-scope="scope">
                    <div>{{scope.row.cusCode}}</div>
                    <div>{{scope.row.encoding}}</div>
                </template>
            </el-table-column>

             <el-table-column label="SKU">
                <template slot-scope="scope">
                        <span>{{scope.row.storeItem.skuName}}</span>
                </template>
            </el-table-column>

            <el-table-column label="length/cm（Required）" >
                <template slot-scope="scope">
                        <el-input @blur="scope.row.storeItem.packageLength=Number(scope.row.storeItem.packageLength)"  v-model="scope.row.storeItem.packageLength"></el-input>
                </template>
            </el-table-column>

            <el-table-column label="width/cm（Required）">
                <template slot-scope="scope">
                        
                        <el-input @blur="scope.row.storeItem.packageWidth=Number(scope.row.storeItem.packageWidth)"  v-model="scope.row.storeItem.packageWidth"></el-input>
                </template>
            </el-table-column>

            <el-table-column label="height/cm（Required）">
                <template slot-scope="scope">
                        <el-input @blur="scope.row.storeItem.packageHeight=Number(scope.row.storeItem.packageHeight)"  v-model="scope.row.storeItem.packageHeight"></el-input>
                </template>
            </el-table-column>

            <el-table-column label="weight/cm（Required）">
                <template slot-scope="scope">
                        
                        <el-input @blur="scope.row.storeItem.weight=Number(scope.row.storeItem.weight)"  v-model="scope.row.storeItem.weight"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="Seller purchase Qty">
                <template slot-scope="scope">
                        <span>{{scope.row.variantNum}}</span>
                </template>
            </el-table-column>

            <el-table-column label="Actual Qty of warehouses" width="350px">
                <template slot-scope="scope">
                    <el-input-number class="vkhjkf" size="mini" v-model="scope.row.actualNum" @change="addNum(scope.row)" :min="0"></el-input-number>
                    <i v-show="scope.row.actualNum == scope.row.variantNum" class="iconfont icon-gouSolid-copy"></i>
                    <i v-show="scope.row.actualNum > scope.row.variantNum" class="iconfont icon-jinggao1"><span style="font-size:14px;margin-left:10px">{{$t('scanIntoStoreage.ytbm')}}</span></i>
                </template>
            </el-table-column>
            
        </el-table>
      </div>
      <div class="messageToStore">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            :placeholder="$t('scanIntoStoreage.rebcd')"
            v-model="textarea2">
          </el-input>
      </div>
  </div>
</template>

<script>
import utils from '../../utils/utils'
import sellerpurchaseApi from '../../api/moudles/sellerpurchase'
import api from '../../api/api.js'
import { showLoading, hideLoading } from '../../assets/js/loading';
export default {
data(){
return{
    pruchaseId:null,
    originData:null,
    purchaseData:{},
    variantList:[],
    flag:false,
    productBarcode:null,
    total:0,
    fee:null,
    textarea2:null
    
}
},
computed:{
    list(){
        let list=JSON.parse(JSON.stringify(this.variantList))
        
        return list
    },
   
},
watch:{
 

},
created(){
    this.init()
},
methods:{

    init(){
        if(this.$route.query.purchaseOrderId){
            this.pruchaseId=this.$route.query.purchaseOrderId
            this.getPurchaseData()
        }
    },

    confirm(){
        let list=JSON.parse(JSON.stringify(this.list))
        let flag=false
        this.list.forEach(p => {
            if(!p.storeItem.packageHeight || !p.storeItem.packageLength || !p.storeItem.packageWidth || !p.storeItem.weight){
                flag=true
               
            }
        })

        if(flag){
             this.$message.warning(this.$t('scanIntoStoreage.rebcj'))
             return 
        }

        list.forEach(i => {
            i.variantNum=i.actualNum
            i.packageHeight=i.storeItem.packageHeight
            i.packageLength=i.storeItem.packageLength
            i.packageWidth=i.storeItem.packageWidth
            i.weight=i.storeItem.weight
        })

        let parmas={
            order:this.originData,
            orderCopy:{
                extraCharge:Number(this.fee),
                messageToSeller:this.textarea2,
                variantList:list,
                storeId:this.originData.storeId,
                userId:this.originData.userId,
                purchaseOrderId:this.originData.purchaseOrderId,
            }
        }

       

        if(this.total !== this.purchaseData.total){
            this.$confirm(this.$t('scanIntoStoreage.nnbhg'), this.$t("other.a142"), {
            confirmButtonText: this.$t('scanIntoStoreage.trbvcm'),
            cancelButtonText: this.$t('scanIntoStoreage.pomv'),
            type: 'warning'
            }).then(() => {
                 console.log('parmas',parmas)
                 this.auditPurchaserData(parmas)

            })
        }else{

            this.$confirm(this.$t('scanIntoStoreage.aswvcx'), this.$t("other.a142"), {
            confirmButtonText: this.$t('scanIntoStoreage.trbvcm'),
            cancelButtonText: this.$t('scanIntoStoreage.pomv'),
            type: 'success'
            }).then(() => {
                 console.log('parmas',parmas)
                 this.auditPurchaserData(parmas)

            })
           
        }


        console.log('parmas',parmas)

        

        

        
    },

    auditPurchaserData(param){
        api
        .auditPurchaseOrder(param)
        .then(res => {
            if (res.code === 200) {
                this.$message.success(this.$t('scanIntoStoreage.dthj'))
                    
            }else{
                this.$message.warning(res.msg)
            }
        })
    },
    tableRowClassName({row, rowIndex}) {
      
        if (rowIndex === 0) {
          return 'warning-row';
        } 
        return '';
    },

    scanProduct(){
        this.productBarcode=this.productBarcode.replace(/\s*/g,"")
        console.log(this.variantList)
        console.log("==1===1====")
        let code = JSON.parse(JSON.stringify(this.productBarcode))
        this.productBarcode=null
        let num=0
        let obj=null
        let target=this.list.find(item => item.storeItem.cusCode == Number(code)  || item.storeItem.encoding == code || item.storeItem.skuName == code)
        
        console.log(target)
        console.log("==2===2====")
        if(!target){
            this.$message.warning(this.$t('scanIntoStoreage.efhn'))
            return
        }
        console.log(this.list)
        console.log("==3===3====")
        
        this.list.forEach((item,index) => {
            if(item.storeItem.cusCode === Number(code) || item.storeItem.encoding == code || item.storeItem.skuName == code){
                num=index
                item.actualNum++
                obj=item
            }  
        })
        console.log('num',num)
        this.list.splice(num,1)
        this.list.unshift(obj)
     

        this.addNum()

       

       
    },
    addNum(){
        this.total=0
        this.list.forEach(p => {
            this.total += p.actualNum
        })

        console.log(this.variantList)
        console.log(this.total)

        
    },
    exportData(){
        console.log(this.list)
        if(this.list.length!=0){
          let list=[]
          this.list.forEach(p => {
            console.log(p)
            list.push({
                'cusCode':p.cusCode+'；'+(p.encoding?p.encoding:''),
                'SKU':p.storeItem.skuName,
  
            })
        })
  
        let arr= ['cusCode','SKU']
        utils.exPortEXml(list,arr,'warehousing products')
       }
    },
    resetOrder(){
        this.purchaseData={}
        this.variantList=[]
        this.flag=false
        this.total=0
        this.fee=null
        this.textarea2=null
    },

    resetNum(){
        this.list.forEach(p => {
            p.actualNum=0
        })
        this.total=0
        this.fee=null
        this.textarea2=null
    },
    getPurchaseData(){
        showLoading()
        this.pruchaseId=this.pruchaseId.replace(/\s*/g,"")
        setTimeout(() => {
            sellerpurchaseApi
            .getPurchaseOrder({
                offset:30,
                page:0,
                purchaseOrderId:this.pruchaseId,
                storeIds:JSON.parse(localStorage.getItem('userInfo')).storeIds,
                userId:JSON.parse(localStorage.getItem('userInfo')).userId
            })
            .then(res => {
            if(res.code === 200 ){
                console.log('1111',res.data)
                this.purchaseData.purchaseOrderId=res.data.list[0].purchaseOrderId
                this.purchaseData.sellerId=res.data.list[0].userId
                this.purchaseData.messageToSeller=res.data.list[0].messageToSeller
                this.purchaseData.total=0
                this.purchaseData.orderFlag=res.data.list[0].orderFlag
                this.purchaseData.productNum=res.data.list[0].variantList.length
                this.purchaseData.actualNum=0

                this.originData=res.data.list[0]
                this.variantList=res.data.list[0].variantList
                this.variantList.forEach(p => {
                    p.encoding=p.storeItem.encoding
                    this.purchaseData.total+=p.variantNum
                    p.actualNum=0
                })
                this.flag=true
                this.pruchaseId=null
                console.log('desc',this.variantList)
                
                console.log('purchaseData',this.purchaseData)
            
            }else{
            this.$message.warning(res.msg)
            }

            hideLoading()
            })
        },1000)
    }
}
}

</script>
<style lang="scss" scoped>
.scanIntoStoreage{
    position: absolute;
    width:100%;
    margin-top:50px;



    /deep/ .el-message-box__message{
        padding: 28px 15px;
        color: #606266;
        font-size: 20px;

        p {
            line-height: 37px;
        }
    }

   

    /deep/ .el-icon-search{
        line-height: 100px;
        font-size: 25px;
       
    }

    /deep/ .el-input-number--mini{
        line-height: 37px;
        font-weight: bold;
        

        .el-input__inner{
            height: 40px;
            font-weight: bold;
        }
    }

    /deep/ .el-input--mini{
        font-size: 25px;
    }

    

    /deep/ .el-input-number__increase{
        font-size: 26px;
    }
    /deep/ .el-input-number__decrease {
        font-size: 26px;
    }

   /deep/ .warning-row {
    background-color: #bff5a1;
    font-size: 25px;
    color: #000;
    font-weight: bold;
  }

   /deep/ .success-row {
    background-color: #419c10;
  }


  .messageToStore{
      margin:  0 15px;
  }

  .vkhjkf{
    width:172px;
    font-weight: bold;
  }

  .icon-gouSolid-copy{
      font-size: 30px;
      color:rgb(42, 165, 21);
      margin:0 15px
  }

  .icon-jinggao1{
      font-size: 30px;
      color:rgb(255, 82, 69);
      margin:0 15px
  }



    .scan_wrapper{
        box-sizing: border-box;
        padding:5px 15px;
        height: 105px;

         /deep/ .el-input__inner{
        height: 100px;
        font-size:25px
    }
    }

    .table{
        margin: 10px 15px;
    }

    .desc_box{
    //    display: flex;
    //     justify-content: space-between;
    box-sizing: border-box;
    padding: 10px;
       
        
        background-color: #000;
        margin: 10px 15px;
        color: #fff;

        .ooi{
            display: flex;
            justify-content: flex-end;
            margin-top: 10px;
        }


        .desc_item{
            margin:0 5px;
            font-size: 16px;
            font-weight: bold;
        }
    }

    .box_wrappr{
       position: relative;
        border: 1px solid #eee;
        margin: 0 15px;
        border-radius: 10px;
    }


    .box {
	           
                text-align: right;
	            margin: 0 135px;
	            overflow: hidden;
                
                border-radius: 5px;
                padding: 5px 15px;
	        }

            .icon-tixing1{
                position: absolute;
                left: 0;
                color: #F56C6C;
                font-size: 25px;
                margin: 0 15px;
            }
	 
	        .animate {
	            padding-left: 20px;
	            font-size: 18px;
	            color: #F56C6C;
	            display: inline-block;
	            white-space: nowrap;
                box-sizing: border-box;
                padding: 0 25px;
	            // animation: 15s wordsLoop linear infinite normal;
	        }
	 
	        // @keyframes wordsLoop {
	        //     0% {
	        //         transform: translateX(200px);
	        //         -webkit-transform: translateX(200px);
	        //     }
	        //     100% {
	        //         transform: translateX(-100%);
	        //         -webkit-transform: translateX(-100%);
	        //     }
	        // }
	 
	        // @-webkit-keyframes wordsLoop {
	        //     0% {
	        //         transform: translateX(200px);
	        //         -webkit-transform: translateX(200px);
	        //     }
	        //     100% {
	        //         transform: translateX(-100%);
	        //         -webkit-transform: translateX(-100%);
	        //     }
	        // }

    
}
</style>